import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  DomSanitizer,
  SafeHtml
} from '@angular/platform-browser';

import sprite from 'icons/workshop.sprite.svg';

import { IconSizeModel }  from './typings/icon.size';
import { IconThemeModel } from './typings/icon.theme';

@Component({
  selector   : 'wor-icon',
  styles: [ require('./icon.component.scss') ],
  template: require('./icon.component.html')
})
export class IconComponent implements OnChanges {
  private _icon: string | SafeHtml;
  public sprite: string = sprite;

  @Input() set icon ( _icon: string | SafeHtml ) {
    this._icon = _icon;

    this._updateIcon();
  }

  @Input() theme : IconThemeModel = 'workshop';
  @Input() size  : IconSizeModel  = 'md';
  @Input() test  : string;

  constructor (
    private sanitizer : DomSanitizer
  ) {}

  ngOnChanges ( changes: SimpleChanges ) : void {
    if (changes.icon || changes.theme) {
      this._updateIcon();
    }
  }

  private _updateIcon () : void {
    if (this._icon && this.isTheme('inline')) {
      this._icon = this.sanitizer.bypassSecurityTrustHtml(this._icon as string);
    }
  }

  isExtraLargeIcon () : boolean {
    return this.size === 'x-lg';
  }

  isLargeIcon () : boolean {
    return this.size === 'lg';
  }

  isSmallIcon () : boolean {
    return this.size === 'sm';
  }

  isTheme ( theme : IconThemeModel = 'workshop' ) : boolean {
    return theme === this.theme;
  }
}
